import React,{useContext} from "react";
import "./bonafide.css";
import { useParams } from "react-router-dom";
import { StudentDetailsContext } from "../store/student-details";
import NumberToWords from "../utils/NumberToWords";
const BonafideTemplate = ({ inputName, inputFatherName }) => {
  const {fromYear,toYear,leavingYear} = useParams();
  const StudentContext = useContext(StudentDetailsContext);
  

  return (
    <div className="layout">
      <div className="innerLayout">
      <div className="Header">
        <div className="NameContainer">
          <div className="headerName ">Name of the Institution : </div>
          <div className="blank_space">TRIVENI HIGH SCHOOL</div>
        </div>

        <div className="addressContainer">
          <div className="address_header">Address:</div>
          <div className="blank_space_address">DOMAKONDA(vill & Mdl) , Dist. KAMAREDDY 503123</div>
        </div>
      </div>
      <div className="bonafideInnerBody">
        <div className="title">
          <p>BONAFIDE AND CONDUCT CERTIFICATE</p>
        </div>
        <div className="body">
          <div className="bodyTopContainer">
            <div className="firstChild">
              <p>No.</p>
              <p>
                Date : <span className="underline_style">{new Date().toLocaleDateString()}</span>
              </p>
            </div>
            <div className="secondChild">
              <div className="d-flex flex-row justify-content-center">
                <p>admission No.</p> <p className="underline_style">{StudentContext.personalDetails.AdmissionNumber}</p>
              </div>
              <div className="d-flex flex-row justify-content-center">
                <p>Aadhar No.</p> <p className="underline_style">{StudentContext.personalDetails.AadharNumber}</p>
              </div>
            </div>
          </div>
          <div className="Paragraph ">
            <div className="leftContent">
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;This is to certify that Master / Kumari</p>
            </div>
            <p className=" rightContent">{StudentContext.personalDetails.Name}</p>
          </div>

          <div className=" Paragraph ">
            <div className="leftContent">
              <p>&nbsp;&nbsp;Son / Daughter of Shri</p>
            </div>
            <p className=" rightContent">{StudentContext.personalDetails.FatherName}</p>
          </div>


          <div className=" Paragraph ">
            <div className="leftContent">
              <p>was / is a bonafide student of this school studied / studying in class from</p>
            </div>
            <p className=" rightContent">{fromYear}</p>
          </div>


          <div className=" ToContainerParagraph ">
            <div className="leftContent ToLeftContent">
              <p>to</p>
            <p className="rightContent">{toYear}</p>

            </div>
            <div className="ToMiddleContent">
              <p className="leftContent">during the years(s) from </p>
              <p className=" rightContent">{StudentContext.personalDetails.AdmissionDate!==null ? new Date(StudentContext.personalDetails.AdmissionDate).getFullYear() : 'N/A'}</p>
            </div>
            <div className="ToRightContent">
              <p className="leftContent">to</p>
              <p className="rightContent">{leavingYear}</p>
            </div>
          </div>

          <div className=" Paragraph ">
            <div className="leftContent">
              <p>His / Her Date of Birth as per the Record is </p>
            </div>
            <p className=" rightContent">{new Date(StudentContext.personalDetails.Dob).toLocaleDateString()}</p>
          </div>

          <div className=" Paragraph ">
            <div className="leftContent">
              <p>in words</p>
            </div>  
            <p className=" rightContent">  
            <NumberToWords date = {new Date(StudentContext.personalDetails.Dob).toLocaleDateString()}/>
            </p>
          </div>


          <div className=" Paragraph ">
            <div className="leftContent">
              <p>His / Her character is / was found</p>
            </div>
            <p className=" rightContent">Good</p>
          </div>
        </div>

        <div className="footer">
          <div>
            <p className="footerText">Head of the Institution </p>
           
          </div>
         
        </div>
      </div>
      </div>
    </div>
  );
};

export default BonafideTemplate;
